import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';



@Injectable({ providedIn: 'root' })
export class AuthenticationService {
    private currentUserSubject: BehaviorSubject<Object>;
    public currentUser: Observable<Object>;

    constructor(private http: HttpClient) {
        this.currentUserSubject = new BehaviorSubject<Object>(JSON.parse(localStorage.getItem('currentUser')));
        this.currentUser = this.currentUserSubject.asObservable();
    }

    public get currentUserValue(): Object {
        return this.currentUserSubject.value;
    }

    login(data) {
        return this.http.post<any>(`https://astrologers.predictforme.com:4050/api/v1/loginAstrologer`, data)
        // return this.http.post<any>(`http://localhost:4051/api/v1/loginAstrologer`, data)
            //return this.http.post<any>(`http://localhost:4050/api/v1/loginAstrologer`, data)
        .pipe(map(user => {
                // login successful if there's a jwt token in the response
                if (user.success ) {
                  /* console.log(user); */
                    // store user details and jwt token in local storage to keep user logged in between page refreshes
                    localStorage.setItem('currentUser', JSON.stringify(user));
                    localStorage.setItem('token',user.token);
                    this.currentUserSubject.next(user);
                  return true;
                }
                else 
                {
                  return false;
                }

              
            }));
    }

    logout() {
        // remove user from local storage to log user out
        localStorage.removeItem('currentUser');
        this.currentUserSubject.next(null);
    }
}